import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { Router } from '@angular/router';
import { EventTypes, OidcSecurityService, PublicEventsService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs';
import { REDIRECT_URL_KEY } from './auth.guard';

/** Signs in again, back to the current page, once the token renewal has failed for good. */
export function provideAuthEvents(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const oidcSecurityService = inject(OidcSecurityService);
    const router = inject(Router);

    inject(PublicEventsService)
      .registerForEvents()
      .pipe(filter((event) => event.type === EventTypes.SilentRenewFailed))
      .subscribe(() => {
        sessionStorage.setItem(REDIRECT_URL_KEY, router.url);
        oidcSecurityService.authorize();
      });
  });
}
